<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-ready-to-pay`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.316 6h39.368C44.964 6 46 6.848 46 7.895V21h-4V10H6v6h8a8 8 0 110 16H6v6h15v4H4.316C3.036 42 2 41.152 2 40.105V7.895C2 6.848 3.037 6 4.316 6zM6 28h8a4 4 0 000-8H6v8zm42 8c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-20 0a8 8 0 1016 0 8 8 0 00-16 0zm10-2v-3a1 1 0 00-1-1h-2a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1v-2a1 1 0 00-1-1h-3zM16 24a2 2 0 10-4 0 2 2 0 004 0z"/></svg>
</template>
<script>

export default {
  name: 'IconReadyToPay',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
